export default (state = {}, action) =>{
    switch(action.type){
        case 'DATA_CHART_PENDING':
            return {...state, data : action.payload}
        default: return state;
    }
}